<template>
  <div class="card countdown-card">
    <div v-show="countdown === -1" class="digit">
      <v-color-icon name="timer" size="30"></v-color-icon>
      <span class="is-text-small">{{ (limit || 10) }}秒</span>
    </div>
    <div v-show="countdown === 0" class="digit">
      <span class="is-text-small">时间到</span>
    </div>
    <div v-show="countdown > 0"
         :style="{transform: `translateY(-${limit-1 - ~~(countdown)}00%)`}"
         class="digit-wrapper">
      <span v-for="i in (limit || 10)" class="digit">{{ (limit || 10) - i }}</span>
    </div>
  </div>
</template>
<script>
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  props: ['limit'],
  data () {
    return {
      countdown: -1,
      stop: false,
      startAt: 0,
      end: 0
    }
  },
  methods: {
    start () {
      this.countdown = (this.limit || 10)
      this.startAt = Date.now()
      this.end = Date.now() + (this.limit || 10) * 1000
      this.updateTimer()
    },
    updateTimer () {
      if (this.stop) {
        return
      }
      const newValue = Math.max(0, ~~((this.end - Date.now()) / 1000))
      if (this.countdown !== newValue) {
        this.countdown = newValue

        if (newValue <= 5 && newValue > 0) {
          IClassroom.playSound('beep')
        }
        if (newValue === 5) {
          this.$noty.info('还剩 5 秒，加油！', { timeout: 5000 })
        }
      }
      if (this.countdown) {
        window.requestAnimationFrame(this.updateTimer)
      }

      if (this.countdown > 0) {
        this.$emit('start')
      } else if (this.countdown === 0) {
        this.$emit('done')
        IClassroom.saySomething('叮叮叮 时间到')
      }
    },
    pause () {
      this.stop = true
    }
  }
}
</script>
<style lang="stylus" scoped>
.card.countdown-card {
  width 60px
  height 60px
  padding 5px 10px
  overflow hidden
  border-radius 50%

  background $link
  color white
  display flex
  justify-content center
}

.digit-wrapper {
  height 100%
  width 100%
  text-align center
  transition all .3s
}

.digit {
  display: inline-flex;
  font-size: 35px
  line-height: 1;
  height 100%
  width 100%
  align-items center
  justify-content center
  flex-direction column
}
</style>
